import {
    DeleteItemRequest,
    DisposalType,
    DeleteItemJsonResponse,
    getServiceAsync,
    TFactories,
} from '../../../../service';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export type DeleteOperationType = 'SoftDelete' | 'HardDelete';

import { runOwsRequestWithMonitor, Feature, fullResponseOperationOption } from '../../../../shared';

function createDeleteItemRequest(
    personaIds: string[],
    deleteType: DisposalType,
    serviceFactory: TFactories
): DeleteItemRequest {
    const ItemIds = personaIds.map((id: string) => {
        return serviceFactory.itemId({ Id: id });
    });
    return serviceFactory.deleteItemRequest({
        ItemIds,
        ReturnMovedItemIds: true,
        DeleteType: deleteType,
    });
}

export function softOrHardDeleteOperation(
    personaIds: string[],
    deleteOperationType: DeleteOperationType
): Promise<DeleteItemJsonResponse> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: deleteOperationType,
            feature: deleteOperationType === 'SoftDelete' ? Feature.SoftDelete : Feature.HardDelete,
            operation: () =>
                service.Operation.deleteItemOperation(
                    service.Factory.deleteItemJsonRequest({
                        Header: getJsonRequestHeader(),
                        Body: createDeleteItemRequest(
                            personaIds,
                            deleteOperationType,
                            service.Factory
                        ),
                    }),
                    fullResponseOperationOption
                ),
            transformResponse: response => response,
        })
    );
}
